export class CloseSiteUrl {
    siteUrls: string[];
}
